export default {"src":"/_next/static/media/arrow-down-black.21849466.svg","height":5,"width":8};